import React from 'react'
import PropTypes from 'prop-types'
import Badge from '../../ui/Badge'
import EditIcon from '../../ui/icons/EditIcon'
import ConditionMenu from './ConditionMenu'
import { stateLabel, kindLabel, conditionValueLabel, sourceLabel, findQuestionLabel } from './helpers'
import { GUTTER, ACTIONS_BOX } from './styles'

const ICON_BTN = 'tw:inline-flex tw:items-center tw:justify-center tw:p-1.5 tw:rounded-md!'
  + ' tw:border-0 tw:bg-transparent tw:cursor-pointer tw:text-gray-500 tw:hover:bg-gray-100'
  + ' tw:hover:text-gray-700 tw:disabled:opacity-40 tw:disabled:cursor-not-allowed'
  + ' tw:disabled:hover:bg-transparent'

const KEYWORD = 'tw:font-bold tw:text-gray-900 tw:shrink-0'
const VALUE = 'tw:min-w-0 tw:break-words tw:text-gray-900'

const ConditionCard = ({
  number, rule, sections, variables, gradeConfig, editDisabled, onEdit, onDuplicate, onDelete
}) => {
  const conditions = rule.conditions.filter(condition => !condition.shouldDestroy)
  const actions = rule.rule_actions.filter(action => !action.shouldDestroy)
  const refs = { sections, variables, gradeConfig }

  return (
    <div className="tw:flex tw:flex-col tw:gap-2 tw:w-full" data-condition-id={rule.uniqueId}>
      <div className="tw:flex tw:gap-2 tw:items-start tw:w-full">
        <span className={GUTTER}>{`#${number}`}</span>
        <div className="tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:gap-2">
          {conditions.map(condition => (
            <div key={condition.uniqueId || condition.id} className="tw:flex tw:flex-col tw:gap-0.5">
              <div className="tw:flex tw:gap-3 tw:items-baseline">
                <span className={KEYWORD}>Si</span>
                <span className={VALUE}>{sourceLabel(sections, variables, condition)}</span>
              </div>
              <div className="tw:flex tw:gap-3 tw:items-baseline">
                <span className={`${KEYWORD} tw:uppercase`}>{stateLabel(condition.state)}</span>
                <span className={VALUE}>{conditionValueLabel(refs, condition)}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="tw:flex tw:gap-0.5 tw:items-start tw:shrink-0">
          <button
            aria-label="Modifier"
            className={ICON_BTN}
            disabled={editDisabled}
            type="button"
            onClick={editDisabled ? null : onEdit}
          >
            <EditIcon title="Modifier" />
          </button>
          <ConditionMenu disabled={editDisabled} onDelete={onDelete} onDuplicate={onDuplicate} />
        </div>
      </div>
      <div className={`${ACTIONS_BOX} tw:ml-[38px]`}>
        {actions.map(action => (
          <div key={action.uniqueId || action.id} className="tw:flex tw:items-center tw:gap-3">
            <Badge variant={action.kind === 'show' ? 'success' : 'progress'}>
              {kindLabel(action.kind).toUpperCase()}
            </Badge>
            <span className={VALUE}>{findQuestionLabel(sections, action.targetable_id)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

ConditionCard.propTypes = {
  editDisabled: PropTypes.bool,
  gradeConfig: PropTypes.shape({ gradeMin: PropTypes.number, gradeSize: PropTypes.number }),
  number: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  rule: PropTypes.shape({ uniqueId: PropTypes.string }).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })).isRequired,
  variables: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number }))
}

ConditionCard.defaultProps = {
  editDisabled: false,
  gradeConfig: null,
  variables: []
}

export default ConditionCard
